import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadNotes, createNote, deleteNote } from './actions';
import List from './List';
import authUtils from '../../auth/utils';
import { initializeForm as initializeCreateNoteForm } from './SettingsForm';
import { initializeForm as initializeSearchForm } from './Filter';
import { Panel } from 'react-bootstrap';

class Notes extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleAddNote = this.handleAddNote.bind(this);
		this.handleDeleteNote = this.handleDeleteNote.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}

	componentDidMount() {
		this.reloadData();
		this.props.initializeSearchForm(this.props.pagination.filter);
	}

	reloadData() {
		const { pagination: { filter, sortKey = 'created', sortDirection = 'desc', pageNumber, pageSize = 50 }, reference, referenceType } = this.props;
		this.props.loadData({ ...filter, reference, referenceType, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleListEvent(listPagination) {
		const { reference, referenceType } = this.props;
		this.props.loadData({ ...this.props.pagination.filter, reference, referenceType, ...listPagination });
	}

	handleAddNote(values) {
		const { reference, referenceType, createNote, onNoteAdded } = this.props;
		createNote({ reference, referenceType, ...values }, () => {
			this.props.initializeCreateNoteForm();
			this.reloadData();
			if (onNoteAdded) {
				onNoteAdded({ reference, referenceType, ...values });
			}
		});
	}

	handleDeleteNote(noteId) {
		const { deleteNote, onNoteDeleted } = this.props;
		deleteNote(noteId, () => {
			this.reloadData();
			if (onNoteDeleted) {
				onNoteDeleted(noteId);
			}
		});
	}

	handleSearch(filter) {
		const { pagination: { sortKey, sortDirection, pageSize }, reference, referenceType } = this.props;
		this.props.loadData({ ...filter, reference, referenceType, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	render() {
		return <Panel>
			<Panel.Body>
				<List onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination}
					isReadOnly={this.props.isReadOnly} onAdd={this.handleAddNote} onDelete={this.handleDeleteNote} onSearch={this.handleSearch} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { notes },
		auth: { currentUser }
	} = state;

	const notesPagination = pagination.notesByReference[`${ownProps.referenceType}-${ownProps.reference}`] || { ids: [], pageNumber: 1, pageSize: 50 };

	return {
		data: notesPagination.ids.map(id => notes[id]),
		pagination: notesPagination,
		isReadOnly: authUtils.hasReadOnlyPermission(currentUser, 'Notes')
	};
};

Notes.propTypes = {
	reference: PropTypes.number.isRequired,
	referenceType: PropTypes.string.isRequired,
	onNoteAdded: PropTypes.func,
	onNoteDeleted: PropTypes.func
};

export default connect(mapStateToProps, {
	loadData: loadNotes,
	createNote,
	deleteNote,
	initializeCreateNoteForm,
	initializeSearchForm
})(Notes);